export default "__VITE_ASSET__l1Pm5wcL__"